import { useContractsImporter } from 'modules/employees/components/ContractImporter/contractsImporterContext'
import { useOnCloseGoToList } from 'modules/employees/hooks/useOnCloseGoList'
import ImportContractsFileSelector from 'modules/employees/pages/ImportContractsPage/components/FileSelector'

const ImportContractsModalPage = () => {
  const onClose = useOnCloseGoToList()
  const importer = useContractsImporter()

  return <ImportContractsFileSelector onClose={onClose} importer={importer} />
}

export default ImportContractsModalPage
